/**
 * Generate from url: https://localhost:44305/swagger/v1/swagger.json
 * It is recommended not to modify the document
 * Total count: 5
 **/
import type {
  JoinUsCreateOrUpdateDto,
  JoinUsDto,
  PagedResultDto,
} from './types';
import { api } from 'boot/axios';

/**
 * *TODO* POST /api/app/join-us
 **/
export function create(payload: JoinUsCreateOrUpdateDto) {
  return api.post<JoinUsDto>('/api/app/join-us', {
    ...payload,
  });
}

/**
 * *TODO* GET /api/app/join-us/{id}
 **/
export function get(id: string) {
  return api.get<JoinUsDto>(`/api/app/join-us/${id}`, {});
}

/**
 * *TODO* GET /api/app/join-us
 **/
export function getList(params: {
  filter?: string | undefined;
  sorting?: string | undefined;
  skipCount?: number | undefined;
  maxResultCount?: number | undefined;
}) {
  return api.get<PagedResultDto<JoinUsDto>>('/api/app/join-us', {
    params: params,
  });
}

/**
 * *TODO* DELETE /api/app/join-us/{id}
 **/
export function remove(id: string) {
  return api.delete<void>(`/api/app/join-us/${id}`, {});
}

/**
 * *TODO* PUT /api/app/join-us/{id}
 **/
export function update(id: string, payload: JoinUsCreateOrUpdateDto) {
  return api.put<JoinUsDto>(`/api/app/join-us/${id}`, {
    ...payload,
  });
}

export default {
  create,
  get,
  getList,
  remove,
  update,
};
